export default "__VITE_ASSET__t70zJ$Ab__"